import React, { useState, useEffect } from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import "./styles.css";

const NewCarousel = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const updateItems = () => {
      if (window.innerWidth < 768) {
        // Smaller devices
        setItems([
          <div className="item" data-value="1">
            <img
              src={require("../../../assets/homepage/hero/slider/Small1.jpg")}
              alt="Mobile Banner 1"
            />
          </div>,
        ]);
      } else if (window.innerWidth < 1024) {
        // Medium devices
        setItems([
          <div className="item" data-value="1">
            <img
              src={require("../../../assets/homepage/hero/slider/Medium1.jpg")}
              alt="Tablet Banner 1"
            />
          </div>,
        ]);
      } else {
        // Larger devices
        setItems([
          <div className="item" data-value="1">
            <img
              src={require("../../../assets/homepage/hero/slider/1.png")}
              alt="Desktop Banner 1"
            />
          </div>,
          <div className="item" data-value="2">
            <img
              src={require("../../../assets/homepage/hero/slider/2.jpg")}
              alt="Desktop Banner 2"
            />
          </div>,
          <div className="item" data-value="3">
            <img
              src={require("../../../assets/homepage/hero/slider/3.jpg")}
              alt="Desktop Banner 3"
            />
          </div>,
        ]);
      }
    };

    updateItems();
    window.addEventListener("resize", updateItems);

    return () => window.removeEventListener("resize", updateItems);
  }, []);

  return (
    <div className="w-[328px] h-[141px] md:w-[720px] md:h-[320px] lg:w-[694px] lg:h-[476px] rounded-[6px] lg:z-30">
      <AliceCarousel
        autoPlay
        // autoPlayControls
        autoPlayStrategy="none"
        autoPlayInterval={1000}
        animationDuration={1000}
        infinite
        animationType="slide"
        touchTracking={false}
        disableDotsControls
        disableButtonsControls
        items={items}
        className="ImgItem"
      />
    </div>
  );
};

export default NewCarousel;
